import { render, staticRenderFns } from "./Top5Driver.vue?vue&type=template&id=16fb70a7"
import script from "./Top5Driver.vue?vue&type=script&lang=js"
export * from "./Top5Driver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16fb70a7')) {
      api.createRecord('16fb70a7', component.options)
    } else {
      api.reload('16fb70a7', component.options)
    }
    module.hot.accept("./Top5Driver.vue?vue&type=template&id=16fb70a7", function () {
      api.rerender('16fb70a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/rank/Top5Driver.vue"
export default component.exports